import { ChangeDetectionStrategy, Component, ViewEncapsulation, model, Input } from '@angular/core';
import { IMediaBankFileReference } from '@fi-shared/media-bank';

@Component({
    selector: 'fi-todo-list-section-item',
    templateUrl: './fi-todo-list-section-item.component.html',
    styleUrls: ['./fi-todo-list-section-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-todo-list-section-item' },
    standalone: false,
})
export class FiTodoListSectionItemComponent {
    @Input() isCompletionDisabled: boolean;
    @Input() description: string;
    @Input() name: string;
    @Input() mediaBankFileReferences: IMediaBankFileReference[];
    public isCompleted = model<boolean>();
}